const getLastDaysChartRange = (days: number): { after: string; before: string } => {
    const before = new Date();
    const after = new Date(before);
    // Use UTC to avoid timezone shifts.
    after.setUTCDate(before.getUTCDate() - days);

    return {
        after: after.toISOString(),
        before: before.toISOString()
    };
};

export const getLast30DaysChartRange = (): { after: string; before: string } => getLastDaysChartRange(30);

export const getLast7DaysChartRange = (): { after: string; before: string } => getLastDaysChartRange(7);

export const getLast60DaysChartRange = (): { after: string; before: string } => getLastDaysChartRange(60);

const HEATMAP_WEEK_COUNT = 26;
const HOUR_DAY_HEATMAP_DAY_COUNT = 14;

const snapToUtcMonday = (date: Date): Date => {
    const utcMidnight = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    const day = utcMidnight.getUTCDay();
    const daysFromMonday = day === 0 ? 6 : day - 1;
    utcMidnight.setUTCDate(utcMidnight.getUTCDate() - daysFromMonday);
    return utcMidnight;
};

/** Six months of daily bins aligned to 26 week columns (26 × 7 days), starting on Monday UTC. */
export const getLast6MonthsChartRange = (): { after: string; before: string; rangeStart: string } => {
    const before = new Date();
    const thisWeekMonday = snapToUtcMonday(before);
    const rangeStart = new Date(thisWeekMonday);
    rangeStart.setUTCDate(thisWeekMonday.getUTCDate() - (HEATMAP_WEEK_COUNT - 1) * 7);

    return {
        after: rangeStart.toISOString(),
        before: before.toISOString(),
        rangeStart: rangeStart.toISOString()
    };
};

/** Two weeks (14 days) of hourly bins for the hour×day activity heatmap. */
export const getLast2WeeksHourDayChartRange = (): { after: string; before: string; rangeStart: string } => {
    const before = new Date();
    const rangeStart = new Date(Date.UTC(before.getUTCFullYear(), before.getUTCMonth(), before.getUTCDate()));
    rangeStart.setUTCDate(rangeStart.getUTCDate() - (HOUR_DAY_HEATMAP_DAY_COUNT - 1));

    return {
        after: rangeStart.toISOString(),
        before: before.toISOString(),
        rangeStart: rangeStart.toISOString()
    };
};
